import { Actions, ActionType, PageType, State } from "./types";

export const otpReducer = (state: State, action: Actions) => {
  switch (action.type) {
    case ActionType.DATA_FETCHED_SUCCESSFULLY: {
      return {
        ...state,
        Page: PageType.OTP_FORM,
        otpResendUrl: action.otpResendUrl,
        otpVerifyUrl: action.otpVerifyUrl,
        maskedMobileNumber: action.maskedMobileNumber,
      };
    }
    case ActionType.ERROR: {
      return { ...state, Page: PageType.ERROR };
    }
    case ActionType.MAX_TRIES_REACHED_ERROR: {
      return { ...state, Page: PageType.MAX_TRIES_REACHED };
    }
    default: {
      return state;
    }
  }
};
